<template>
  <div style="height: 100%">
    <BottomSheet :open="openOrderList" @handleClose="closeBottomSheet" :orderData="cafe24OrderList" />
    <Header ref="header" :isBack="false" :isHistory="true"></Header>
    <div class="chatCon">
      <div class="msgCon">
        <!--  msgBox -->
        <div
          class="msgBox"
          :style="{ backgroundColor: brandQuery.channelType === 'chat' || showInput || !isPadding ? '#e5e8f2' : '#efe9f0' }"
          @click="closeKeyboard"
        >
          <!-- // 어바웃펫 입력 감지 커스텀 isTyping : 40px -->
          <MsgList
            ref="scrollList"
            class="msgList"
            :style="{
              paddingBottom: !isPadding || showInput ? (isTyping ? '40px' : isAiAnswerLottie ? '40px' : '20px') : '70px',
              'background-color': isRoundCustom ? '#fcffe9' : 'transparent'
            }"
            :messages="messages"
            :chatRoomId="chatRoomId"
            :is-not-available="isNotAvailable"
            :setFaq="setFaq"
            :isUseBubble="isUseBubble"
            @openBottomSheet="checkCafe24Member"
            @connectConsultant="connectConsultant"
          ></MsgList>
          <!-- // 어바웃펫 입력 감지 커스텀 -->
          <div style="position: absolute; bottom: 10px; left: 10px; z-index: 1000" v-if="isTyping && !isHansalimCustom">
            <aboutPetLottie :options="aboutPetAnimationData" :width="100" :height="36" />
          </div>
          <!-- // 한살림 입력 감지 커스텀 -->
          <div style="position: absolute; bottom: 0px; left: -40px; z-index: 1000" v-if="isTyping && isHansalimCustom">
            <hansalimLottie :options="hansalimAnimationData" :width="180" :height="80" />
          </div>
          <!-- // AI 답변 감지 커스텀 -->
          <div style="position: absolute; bottom: 5px; left: -10px; z-index: 1000" v-if="isAiAnswerLottie">
            <aiAnswerLottie :options="aiAnswerData" :width="100" :height="50" />
          </div>
        </div>
        <!-- sendBox -->
        <div v-if="showInput" class="sendBox">
          <form ref="form" autocomplete="off">
            <div class="file" v-if="!isHectoBrand && !isNoFileCustom">
              <a><i class="UXicon-attach_outlined"></i></a>
              <input type="file" accept="image/*, video/*" @change="fileChangeListener" />
            </div>
            <div class="inp" :class="{ isTextareaFocus: isTextareaFocus || message, noFilePadding: isNoFileCustom }">
              <div class="box">
                <input
                  v-if="isHectoBrand && isMobile"
                  type="number"
                  pattern="[0-9]*"
                  v-model="message"
                  ref="msgTextarea"
                  @click="scrollTo"
                  @focus="textareaFocus"
                  @blur="isTextareaFocus = false"
                  @keydown="resizeMsgText"
                  @keyup="resizeMsgText"
                  @keypress.enter.exact="enterEvent"
                  placeholder="상담사에게 메시지 보내기"
                  :autocomplete="isHectoBrand ? 'one-time-code' : 'off'"
                  :style="{ backgroundColor: message || isTextareaFocus ? '#ffffff' : 'transparent' }"
                />
                <textarea
                  v-else
                  v-model="message"
                  ref="msgTextarea"
                  @click="scrollTo"
                  @focus="textareaFocus"
                  @blur="isTextareaFocus = false"
                  @keydown="resizeMsgText"
                  @keyup="resizeMsgText"
                  @keypress.enter.exact="enterEvent"
                  :placeholder="isCounselorNameCustom ? '상담직원에게 메시지 보내기' : '상담사에게 메시지 보내기'"
                  :autocomplete="isHectoBrand ? 'one-time-code' : 'off'"
                  :style="{ backgroundColor: message || isTextareaFocus ? '#ffffff' : 'transparent' }"
                >
                </textarea>
                <input type="text" ref="hiddenInput" class="iosInputBug" />
              </div>

              <a @click="sendMessage('TEXT')"><i class="UXicon-send" :style="{ color: isIconColor || message ? '#5578F0' : '#DCDCDC' }"></i></a>
            </div>
          </form>
        </div>
        <!-- btmBtn -->
        <div v-if="gnbs.length > 0 && !isHectoBrand && !isWebchatChannel" class="btmBtn">
          <a @click="goToPrevious" :style="{ color: isRoundCustom ? '#3f5710' : '#3f36a5' }"
            ><i class="UXicon-return" :style="{ color: isRoundCustom ? '#3f5710' : '#3f36a5' }"></i>이전으로</a
          >
          <a @click="goHome" :style="{ color: isRoundCustom ? '#3f5710' : '#3f36a5' }"
            ><i class="UXicon-restart" :style="{ color: isRoundCustom ? '#3f5710' : '#3f36a5' }"></i>처음으로</a
          >
          <!--                    <a @click="closeChatRoom"><i class="UXicon-fin"></i>상담종료</a>-->
        </div>
        <span class="packageVersion">Powered by cloudgate v{{ packageVersion }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import MsgList from './components/MsgList';
import Header from '../../components/Header';
import webSocket from '@/util/websocket';
import helpers from '@/util/helpers';
import { mapGetters, mapMutations } from 'vuex';
import { webchatLayoutHelper } from '@/components/mixin/custom/search';
import aboutPetLottie from '@/components/custom/aboutPetLottie/AboutPetLottie.vue'; // 어바웃펫 입력 감지 커스텀
import hansalimLottie from '@/components/custom/hansalimLottie/HansalimLottie.vue'; // 한살림 입력 감지 커스텀
import aiAnswerLottie from '@/components/custom/aiAnswerLottie/AiAnswerLottie.vue'; // AI 답변 감지 커스텀
import animationData from '@/assets/custom/animation/AboutPet.json';
import hansalimAniData from '@/assets/custom/animation/Hansalim.json';
import aiAnswerData from '@/assets/custom/animation/AiAnswer.json';
import { getHectoRoundList, getNameCustomList, getNoFileCustomList } from '@/constants/customInfo';
import apiService from '@/http/api';
import BottomSheet from './components/BottomSheet';

const packageConfig = require('@/../package.json');

export default {
  name: 'WebChat',
  mixins: [webchatLayoutHelper],
  components: {
    Header,
    MsgList,
    aboutPetLottie, // 어바웃펫 입력 감지 커스텀
    hansalimLottie, // 한살림 입력 감지 커스텀
    BottomSheet,
    aiAnswerLottie // AI 답변 감지 커스텀
  },
  data() {
    return {
      brandQuery: window.sessionStorage.getItem('BRAND_QUERY') ? JSON.parse(window.sessionStorage.getItem('BRAND_QUERY')) : undefined,
      message: '',
      isIconColor: false,
      loading: false,
      file: null,
      imageName: '',
      imagePath: '',
      jsonContent: '{}',
      showInput: false,
      chatRoomId: null,
      gnbs: [],
      messages: [],
      brandKey: '',
      scenarioId: null,
      senderUid: window.localStorage.getItem(process.env.VUE_APP_LOGIN_ID) || window.localStorage.getItem(process.env.VUE_APP_UUID_KEY),
      channelType: '',
      isEnd: false,
      isChatBotEnd: false,
      isTextareaFocus: false,
      isPadding: false,
      initialScreenSize: window.screen.height,
      isHectoBrand: false,
      // <!-- 어바웃펫 입력 감지 커스텀
      isTyping: false,
      oldTypingMessage: '',
      typingInterval: null,
      typingCheck: false,
      brandId: 0,
      aboutPetAnimationData: { animationData },
      // 어바웃펫 입력 감지 커스텀 -->
      // <!-- 어바웃펫 입력 감지 버블버튼 커스텀
      hansalimAnimationData: { animationData: hansalimAniData },
      isUseBubble: false,
      // 어바웃펫 입력 감지 버블버튼 커스텀 -->
      // <!-- AI 답변 감지 커스텀
      aiAnswerData: { animationData: aiAnswerData },
      isAiAnswerLottie: false,
      // AI 답변 감지 커스텀 -->
      packageVersion: packageConfig.version,
      openOrderList: false,
      cafe24OrderList: [],
      isLoadingOrderList: false,
      channelName: ''
    };
  },
  watch: {
    showInput(val) {
      this.setShowInput(val);
    },
    isEnd(val) {
      this.setIsEnd(val);
    },
    message(val) {
      // 어바웃펫 입력 감지 커스텀, 한살림 입력 감지 커스텀
      if (this.isAboutPetCustom || this.isHansalimCustom) {
        this.oldTypingMessage = val;
        clearTimeout(this.typingInterval); // 이전 인터벌 종료
        // 새 인터벌 시작
        this.typingInterval = setTimeout(() => {
          if (this.oldTypingMessage === this.message) {
            // 메세지를 변경하지 않고 이전상태로 돌아온 경우
            this.typingCheck = false;
            clearTimeout(this.typingInterval);
            webSocket.keyboardTypingSend({ brandId: this.brandId, typing: false, chatRoomId: this.chatRoomId });
          }
        }, 10000);
        if (!this.typingCheck && this.message.length > 0) {
          // 메세지를 작성하는 중인 경우
          this.typingCheck = true;
          webSocket.keyboardTypingSend({ brandId: this.brandId, typing: true, chatRoomId: this.chatRoomId });
        } else if (this.message.length === 0) {
          // 메세지를 전부 삭제한 경우
          this.typingCheck = false;
          clearTimeout(this.typingInterval);
          webSocket.keyboardTypingSend({ brandId: this.brandId, typing: false, chatRoomId: this.chatRoomId });
        }
      }
    },
    messages(val) {
      this.setMessagesData(val);
      if (this.brandQuery.channelType === 'chat') {
        this.scrollTo();
      }
    },
    chatRoomId(val) {
      // window.sessionStorage.setItem('CURRENTLY_CHATROOM', val)
      this.setChatRoomId(val);
    }
  },
  computed: {
    ...mapGetters(['chatRoomData', 'getBrandId']),
    isMobile() {
      return helpers.isMobile();
    },
    isAboutPetCustom() {
      // 어바웃펫 입력 감지 커스텀
      if (!this.chatRoomData.customOptionInfos) {
        return false;
      }
      return this.chatRoomData.customOptionInfos.find((option) => option.name === 'QnA').use;
    },
    isHansalimCustom() {
      // 한살림 입력 감지 커스텀
      if (!this.chatRoomData.customOptionInfos) {
        return false;
      }
      return this.chatRoomData.customOptionInfos.find((option) => option.name === 'INPUT_IN_PROGRESS').use;
    },
    isRoundCustom() {
      return getHectoRoundList().brands.includes(this.getBrandId);
    },
    isCounselorNameCustom() {
      return getNameCustomList().brands.includes(this.getBrandId);
    },
    isNoFileCustom() {
      return getNoFileCustomList().brands.includes(this.getBrandId);
    },
    isWebchatChannel() {
      return this.channelName === 'WEB_CHAT';
    }
  },
  created() {
    if (this.isMobile && !navigator.userAgent.indexOf('Android') > -1) {
      // IOS 대응
      let prevVisualViewport = 0;
      this.handleVisualViewportResize = () => {
        const currentVisualViewport = window.visualViewport.height;
        if (prevVisualViewport - 30 > currentVisualViewport && prevVisualViewport - 100 < currentVisualViewport) {
          const scrollHeight = window.document.scrollingElement.scrollHeight;
          const scrollTop = scrollHeight - window.visualViewport.height;
          window.scrollTo(0, scrollTop); // 입력창이 키보드에 가려지지 않도록 조절
        }
        prevVisualViewport = window.visualViewport.height;
      };
      window.visualViewport.onresize = this.handleVisualViewportResize;
    }

    this.brandKey = this.brandQuery.brandKey;
    this.channelType = this.brandQuery.channelType;
    this.scenarioId = this.brandQuery.scenarioId || null;
    this.messages = this.chatRoomData.messagesData || [];
    this.showInput = this.chatRoomData.showInput || false;
    this.chatRoomId = this.chatRoomData.chatRoomId || null;
    this.gnbs = this.chatRoomData.gnbs || [];

    const lastMessages = this.chatRoomData && this.chatRoomData.messagesData;
    if (lastMessages && lastMessages.length > 0) {
      this.channelName = lastMessages[lastMessages.length - 1].channelName;
    } else {
      this.channelName = '';
    }

    if (this.messages.length > 0) {
      this.messages.map((d) => {
        if (d.channelName === 'SCENARIO' && d.messageType === 'END') {
          this.isChatBotEnd = true;
        }
      });
    }
  },
  beforeMount() {
    this.senderUid = window.localStorage.getItem(process.env.VUE_APP_LOGIN_ID) || window.localStorage.getItem(process.env.VUE_APP_UUID_KEY);
    if (!this.chatRoomData.chatRoomId && this.chatRoomData.messagesData.length === 0) {
      this.openChatRoom();
    } else {
      this.isEnd = this.chatRoomData.isEnd;
      this.brandId = this.getBrandId;
    }
  },
  mounted() {
    this.isPadding = this.channelType === 'scenario';
    if (helpers.isMobile()) {
      this.$refs.scrollList.$el.addEventListener('touchmove', () => {
        document.activeElement.blur();
      });
    }
    document.addEventListener('visibilitychange', this.visibilitychange);
    this.visibilitychange();
    document.querySelector('.msgBox').classList.add('transition');
    window.$mitt.on('subscribeBody', this.subscribeBody);
  },
  beforeDestroy() {
    window.$mitt.off('subscribeBody', this.subscribeBody);
    document.removeEventListener('visibilitychange', this.visibilitychange);
  },
  methods: {
    ...mapMutations(['setMessagesData', 'setChatRoomId', 'setShowInput', 'setGnbs', 'setIsEnd', 'setBrandId', 'setChannelName']),
    subscribeBody(body) {
      switch (body.changeType) {
        case 'NEW_CHAT_MESSAGE':
          this.newChatMessageSubscribe(body.data);
          break;
        case 'CLOSE_CHAT_ROOM':
          this.isPadding = false;
          this.gnbs = [];
          this.isAiAnswerLottie = false;
          this.closeChatRoomSubscribe(body.data);
          break;
        // 진행중인 챗룸의 고객정보와 현재 고객 정보가 다를 경우 (유저가 캐시를 삭제 한 경우 해당)
        case 'INVALID_CHAT_ROOM_CUSTOMER':
          break;
        // 상담사 연결 대기 및 연결
        case 'UPDATE_WEBCHAT_KEYBOARD':
          this.updateKeyboardSubscribe(body.data);
          break;
        case 'EXTERNAL_ACTION':
          this.externalActionSubscribe(body.data);
          break;
        // 챗봇 -> 웹챗 변경
        case 'CONSULT_NEW_CHAT_ROOM':
          this.changeChatRoomSubscribe(body.data);
          break;
        case 'EXTERNAL_PAGE_OPEN':
          this.openExternalPage(body.data.url);
          break;
        case 'CHANGE_TO_EXISTED_CHAT_ROOM':
          this.openExistChatRoom(body.data);
          break;
        case 'KEYBOARD_TYPING_SENSOR': // 어바웃펫 입력 감지 커스텀
          this.changeTyping(body.data);
          break;
      }
    },
    visibilitychange() {
      if (document.visibilityState === 'visible' && this.chatRoomData.chatRoomId) {
        this.$http({
          method: 'GET',
          url: `/api/external/chat/${this.chatRoomId}/messages`,
          params: {
            page: 1,
            size: 100000,
            userKey: this.senderUid,
            brandKeyEncrypt: JSON.parse(window.sessionStorage.getItem('BRAND_QUERY')).brandKey
          }
        }).then((result) => {
          const res = result.data;
          this.messages = [];
          res.data.forEach((message) => {
            let content = JSON.parse(message.content);
            message.isAiBotIcon = content.isBotAgentConnect ? content.isBotAgentConnect : false;
            this.pushMessage(message);
          });
        });
      }
    },
    parseBase64String(base64String) {
      return atob(base64String);
    },
    openExternalPage(url) {
      this.isEnd = true;
      this.$mitt.emit('openWindow', url.indexOf('http') === -1 ? window.location.origin + url : url);
    },
    closeChatRoomSubscribe(data) {
      // 상담사가 종료할 경우 처리
      if (data.chatRoomId === this.chatRoomId) {
        this.showInput = false;
        this.isEnd = true;
        window.sessionStorage.removeItem('SCENARIO_CHECK_DATA');
        try {
          window.parent.postMessage({ messageType: 'STATUS', data: data.status }, '*');
        } catch (e) {
          console.log('postMessage STATUS failed', e);
        }

        // 헥토이노베이션 커스텀
        window.localStorage.removeItem('showHectoKeyboard');
      }
    },
    newChatMessageSubscribe(data) {
      if (data.chatRoomId === this.chatRoomId) {
        let jsonContent = JSON.parse(data.lastMessageInfo.content);

        // AI 답변 감지 커스텀
        if (data.lastMessageInfo.senderType === 'USER') {
          this.isAiAnswerLottie = jsonContent.isBotAgentConnect;
        } else {
          this.isAiAnswerLottie = false;
        }
        data.lastMessageInfo.isAiBotIcon = jsonContent.isBotAgentConnect ? jsonContent.isBotAgentConnect : false;

        this.checkStartSign(data);
        this.pushMessage(data.lastMessageInfo);
        this.addGnbs(data.lastMessageInfo);
      }
    },
    // 시나리오 버튼 타입에 따른 액션 처리
    externalActionSubscribe(data) {
      if (data.chatRoomId === this.chatRoomId) {
        let content = data.content;
        if (content === '') {
          return;
        }

        if (data.action === 'COUNSELOR_BUTTON') {
          this.$http({
            method: 'POST',
            url: content.data,
            data: {}
          }).then((res) => {
            if (res.data.code !== 0) {
              if (res.data.code === -1035 || res.data.code === -3009) return;
              this.$mitt.emit('DialogPopup', {
                useDialog: true,
                message: '<dl class="txt"><dd>' + res.data.message + '</dd></dl>'
              });
            } else {
              this.isChatBotEnd = true;
            }
          });
        }
        this.addGnbs(data);
      }
    },
    // 웹챗 챗봇 연결시 중복 생성 방지
    openExistChatRoom(data) {
      this.$http({
        method: 'GET',
        url: '/api/brand/searchChannels',
        params: {
          brandId: data.brandId
        }
      }).then((result) => {
        if (result.data.code !== 0) {
          this.$mitt.emit('DialogPopup', {
            useDialog: true,
            message: '<dl class="txt"><dd>' + result.data.message + '</dd></dl>'
          });
          return;
        }
        const res = result.data.data;
        if (res.length === 0) {
          return;
        }
        res.forEach((channel) => {
          if (channel.name === 'WEB_CHAT') {
            this.chatRoomId = data.newChatRoomId;
            data.messages.forEach((message) => {
              let content = JSON.parse(message.content);
              message.isAiBotIcon = content.isBotAgentConnect ? content.isBotAgentConnect : false;
              this.pushMessage(message);
            });
          }
        });
        this.showInput = true;
      });
    },
    // 챗봇 -> 웹챗 연결시 새로은 상담방 생성
    changeChatRoomSubscribe(data) {
      if (data.chatRoomId === this.chatRoomId) {
        this.chatRoomId = data.newChatRoomId;
        this.isPadding = false;
        this.setChannelName('WEB_CHAT');
      }
    },
    // 키보드 활성화 소켓으로 변경 (다중창 고려)
    updateKeyboardSubscribe(data) {
      if (data.chatRoomId === this.chatRoomId) {
        this.setChatRoomId(data.chatRoomId);
        this.showInput = data.showWebChatKeyboard;
      }
    },
    addGnbs(data) {
      this.gnbs = [];
      if (data.gnbs) {
        data.gnbs.forEach((gnb) => {
          this.gnbs.push({ text: gnb.text, type: gnb.type });
        });
        this.setGnbs(this.gnbs);
      }
    },
    checkStartSign(data) {
      if (data.lastMessageInfo.messageType === 'START') {
        try {
          window.parent.postMessage({ messageType: 'STATUS', data: data.status }, '*');
        } catch (e) {
          console.log('postMessage STATUS failed', e);
        }
      }
    },
    pushMessage(message) {
      let checkId = this.messages.filter((d) => d.id === message.id);
      if (message.messageType === 'BROWSER_EXIT' || checkId.length > 0) {
        return false;
      }
      if (message.createDate === undefined) {
        message.createDate = this.$moment().format('YYYYMMDDHHmmss');
      }
      if (message.channelName === 'SCENARIO' && message.messageType === 'END') {
        this.isChatBotEnd = true;
      }

      this.messages.push({
        id: message.id,
        senderType: message.senderType,
        senderName: message.senderName,
        messageType: message.messageType,
        content: message.content,
        channelName: message.channelName ? message.channelName : this.chatRoomData.channelName,
        createDate: message.createDate,
        isAiBotIcon: message.isAiBotIcon ? message.isAiBotIcon : false
      });
      this.setMessagesData(this.messages);
      if (message.messageType === 'END') {
        setTimeout(() => {
          this.isChatBotEnd = true;
        }, 3000);
      }
    },
    convertContent(messageType, data) {
      let content = {};
      if (messageType === 'TEXT') {
        content.text = data;
        return JSON.stringify(content);
      } else if (messageType === 'PHOTO' || messageType === 'VIDEO') {
        content.url = data;
        return JSON.stringify(content);
      }
    },
    sendScenario(item) {
      // 버튼을 클릭하면, 서버에서 판단(다음시나리오, 링크연결, 전화연결 등) 하여 웹소켓으로 전송해주는 방식
      this.$http({
        method: 'POST',
        url: '/api/external/webchat/sendMessage',
        data: {
          senderUid: this.senderUid,
          chatRoomId: this.chatRoomId,
          messageType: 'SCENARIO',
          scenarioTemplateCode: item.code,
          content: JSON.stringify(item)
        }
      }).then((res) => {
        if (res.data.code !== 0) {
          if (this.isNotAvailable(res.data)) return;
          this.$mitt.emit('DialogPopup', {
            useDialog: true,
            message: '<dl class="txt"><dd>' + res.data.message + '</dd></dl>'
          });
        }
      });
    },
    sendMessage(messageType) {
      if (this.loading === false) {
        try {
          if (this.$refs.hiddenInput) {
            this.$refs.hiddenInput.focus();
          }
        } catch (e) {
          console.log(e);
        }
        this.$refs.msgTextarea.focus();
        // TODO: 사용자가 중간에 캐시를 초기화할 수 있기에 메세지 전송시점마다 가져와서 전달하도록 하며
        // TODO: 초기화 된 경우 모든 리스트를 초기화 하는 로직을 잊지말고 구현 할 것
        this.loading = true;

        if (messageType === 'PHOTO' || messageType === 'VIDEO') {
          if (this.imagePath === '') {
            this.loading = false;
            return;
          }
          this.jsonContent = this.convertContent(messageType, this.imagePath);
        } else {
          if (this.message.length === 0) {
            this.loading = false;
            return;
          }
          if (this.message.length > 1000) {
            this.$mitt.emit('DialogPopup', {
              useDialog: true,
              message: '<dl class="txt"><dd>최대 1000자 까지 전송 가능 합니다</dd></dl>'
            });
            this.loading = false;
            return;
          }
          this.jsonContent = this.convertContent(messageType, this.message);
          this.message = '';
        }
        this.$http({
          method: 'POST',
          url: '/api/external/webchat/sendMessage',
          data: {
            senderUid: this.senderUid,
            chatRoomId: this.chatRoomId,
            messageType: messageType,
            content: this.jsonContent
          }
        })
          .then(
            (res) => {
              setTimeout(this.resizeMsgText, 0);
              if (res.data.data && res.data.data.url) {
                this.$mitt.emit('DialogPopup', {
                  useDialog: true,
                  message: `<dl class="txt"><dt>설문조사하기</dt><dd class="autoScroll">${res.data.data.description}</dd></dl>`,
                  getBtnCount: 2,
                  getCloseBtnName: '다음에 할래요',
                  getBtnName: '참여하기',
                  getButtonEvent: () => {
                    this.$mitt.emit('windowOpen', {
                      url: res.data.data.url,
                      target: 'urlWindow',
                      features: 'height=' + screen.height + ',width=' + screen.width + 'fullscreen=no'
                    });
                  }
                });
              }
            },
            () => {
              this.$mitt.emit('DialogPopup', {
                useDialog: true,
                message: '<dl class="txt"><dd>메세지 전송 과정에서 문제가 발생하였습니다.</dd></dl>'
              });
            }
          )
          .catch((errorMsg) => {
            this.$mitt.emit('DialogPopup', {
              useDialog: true,
              message: '<dl class="txt"><dd>' + errorMsg + '</dd></dl>'
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    fileChangeListener(event) {
      let file = event.target.files[0];

      // 취소한 경우 크롬은 초기화 되기에
      if (file === undefined) return;

      if (!helpers.getFileType(file)) return;

      const { size, sign } = helpers.formatBytes(file.size);
      if (['Bytes', 'KB'].indexOf(sign) === -1) {
        const limitSize = 200;
        const limitSign = 'MB';
        if ((sign === limitSign && size > limitSize) || sign !== limitSign) {
          this.$mitt.emit('DialogPopup', {
            useDialog: true,
            message: `<dl class="txt"><dd>파일 업로드 가능한 제한 용량은 ${limitSize}${limitSign} 입니다.</dd></dl>`,
            getButtonEvent: () => {
              event.target.value = '';
            }
          });
          return;
        }
      }

      this.loading = true;
      const formData = new FormData();

      formData.append('file', file);
      formData.append('loginId', this.senderUid);

      this.$http({
        url: '/api/external/fileUpload',
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData
      })
        .then(
          (res) => {
            if (res.data.code !== 0) throw res.data.message;

            this.imageName = file.name;
            this.imagePath = res.data.data.imageUrl;
            this.loading = false; // sendMessage 에서 loading 을 선 체크 하기에 추후 고려 해볼 것

            this.sendMessage(helpers.getFileType(file));
          },
          () => {
            this.$mitt.emit('DialogPopup', {
              useDialog: true,
              message: '<dl class="txt"><dd>이미지 업로드 과정에서 문제가 발생하였습니다.</dd></dl>'
            });
          }
        )
        .catch((errorMsg) => {
          this.$mitt.emit('DialogPopup', {
            useDialog: true,
            message: '<dl class="txt"><dd>' + errorMsg + '</dd></dl>'
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    goToPrevious() {
      const item = { code: 'PREV', text: '이전으로' };
      this.sendScenario(item);
    },
    goHome() {
      const item = { code: 'HOME', text: '처음으로' };
      this.sendScenario(item);
    },
    openChatRoom() {
      const brandData = {
        brandKeyEncrypt: this.brandKey,
        senderUid: this.senderUid,
        type: this.channelType,
        deviceToken: this.brandQuery.did ? this.brandQuery.did : null,
        deviceType: this.brandQuery.platformType ? this.brandQuery.platformType.toUpperCase() : null,
        appId: this.brandQuery.appId ? this.brandQuery.appId : null
      };
      const query = this.$route.query;
      let data;

      if (this.scenarioId) {
        brandData.scenarioId = this.parseBase64String(this.scenarioId);
      }
      if (this.$isSeller) {
        delete query.brandKey;
        delete query.channelType;
        delete query.scenarioId;
        data = Object.assign(brandData, query);
      } else {
        if (this.$route.query.ticketId) {
          brandData.ticketId = this.$route.query.ticketId;
        }
        delete query.brandKey;
        delete query.channelType;
        delete query.scenarioId;
        delete query.ticketId;
        const customParameters = Object.keys(query).map((d) => {
          return {
            customParameterKey: d,
            customParameterValue: query[d]
          };
        });
        data = Object.assign(brandData, {
          customParameters: customParameters
        });
      }
      this.$http({
        method: 'POST',
        url: '/api/external/webchat/v2/openChatRoom',
        data: data
      }).then((res) => {
        if (res.data.code !== 0) {
          if (this.isNotAvailable(res.data)) return;
          this.$mitt.emit('DialogPopup', {
            useDialog: true,
            message: '<dl class="txt"><dd>' + res.data.message + '</dd></dl>'
          });
          this.isEnd = true;
          return;
        }
        let data = res.data.data;

        window.sessionStorage.setItem(
          'CURRENTLY_CHATROOM',
          JSON.stringify({
            id: data.chatRoomId,
            status: data.status
          })
        );

        this.messages = [];
        this.gnbs = [];
        this.showInput = data.showWebChatKeyboard;
        this.chatRoomId = data.chatRoomId;
        this.brandName = data.brandName;
        this.brandId = data.chatMessages ? data.chatMessages[0].brandId : this.getBrandId;

        if (data.chatMessages && data.chatMessages.length > 0) {
          this.channelName = data.chatMessages[data.chatMessages.length - 1].channelName;
        } else {
          this.channelName = '';
        }
        this.setChannelName(this.channelName);
        this.setBrandId(this.brandId);

        data.chatMessages.forEach((message) => {
          // 한살림 버블버튼 사용 커스텀
          let jsonContent = JSON.parse(message.content);
          if (jsonContent.useBubbleChat) {
            this.isUseBubble = jsonContent.useBubbleChat;
          }

          message.isAiBotIcon = jsonContent.isBotAgentConnect ? jsonContent.isBotAgentConnect : false;
          this.pushMessage(message);
        });
        this.addGnbs(data);
        this.$gtag.event(this.channelType, {
          event_category: this.$route.query.appId ? this.brandName + '_APP' : this.brandName,
          event_label: this.senderUid
        });
        try {
          if (this.$isIframe) {
            window.parent.postMessage({ messageType: 'STATUS', data: data.status }, '*');
          } else if (window.opener) {
            window.opener.postMessage({ messageType: 'STATUS', data: data.status }, '*');
          }
        } catch (e) {
          console.log('postMessage STATUS failed', e);
        }
      });
    },
    closeChatRoom() {
      if (!this.chatRoomId) return false;
      this.$mitt.emit('DialogPopup', {
        useDialog: true,
        message: '<dl class="txt"><dt>상담종료하기</dt><dd>확인을 누르시면 상담이 종료됩니다.<br />종료하시겠습니까?</dd></dl>',
        getBtnCount: 2,
        getButtonEvent: () => {
          this.$http({
            method: 'POST',
            url: '/api/external/webchat/closeChatRoom',
            data: {
              chatRoomId: this.chatRoomId
            }
          }).then((res) => {
            if (res.data.code !== 0) {
              this.$mitt.emit('DialogPopup', {
                useDialog: true,
                message: '<dl class="txt"><dd>' + res.data.message + '</dd></dl>'
              });
            } else {
              if (res.data.data && res.data.data.url) {
                this.$mitt.emit('DialogPopup', {
                  useDialog: true,
                  message: `<dl class="txt"><dt>설문조사하기</dt><dd class="autoScroll">${res.data.data.description}</dd></dl>`,
                  getBtnCount: 2,
                  getCloseBtnName: '다음에 할래요',
                  getBtnName: '참여하기',
                  getCloseButtonEvent: () => {
                    window.sessionStorage.removeItem('SCENARIO_CHECK_DATA');
                    window.sessionStorage.removeItem('CURRENTLY_CHATROOM');
                    this.isEnd = true;
                  },
                  getButtonEvent: () => {
                    window.sessionStorage.removeItem('SCENARIO_CHECK_DATA');
                    window.sessionStorage.removeItem('CURRENTLY_CHATROOM');
                    this.isEnd = true;
                    this.$mitt.emit('windowOpen', {
                      url: res.data.data.url,
                      target: 'urlWindow',
                      features: 'height=' + screen.height + ',width=' + screen.width + 'fullscreen=no'
                    });
                  }
                });
              }
            }
          });
        }
      });
    },
    isNotAvailable(data) {
      switch (data.code) {
        case -1035:
        case -3009:
          this.isEnd = true;
          return true;
        case -503:
          this.isEnd = false;
          this.$mitt.emit('DialogPopup', {
            useDialog: true,
            message: '<dl class="txt"><dd>지금은 상담량이 많아 상담사 연결이 원할하지 않습니다.<br />잠시 후 다시 시도해 주세요.</dd></dl>'
          });
          return true;
        case -11003:
          this.isEnd = true;
          this.$mitt.emit('DialogPopup', {
            useDialog: true,
            message: '<dl class="txt"><dd>이용기간이 만려되어 사용이 불가능합니다.</dd></dl>'
          });
          return true;
        case -11011:
          this.isEnd = true;
          this.$mitt.emit('DialogPopup', {
            useDialog: true,
            message: '<dl class="txt"><dd>챗봇이 비활성화 되어있어 이용이 불가능합니다.</dd></dl>'
          });
          return true;
        case -11014:
          this.isEnd = true;
          this.$mitt.emit('DialogPopup', {
            useDialog: true,
            message:
              '<dl class="txt"><dd>현재 사용할 수 없는 챗봇입니다.<br/>잠시 후 다시 시도해주세요.<br/> 지속적으로 발생할 경우 고객센터로 문의해주세요.<br/></dd></dl>'
          });
          return true;
        default:
          return false;
      }
    },
    scrollTo() {
      // if (helpers.isMobile()) {
      setTimeout(() => {
        const container = this.$refs.scrollList.$el;
        container.scrollTop = container.scrollHeight;
        window.document.body.scrollTop = container.scrollHeight;
      }, 300);
      // }
    },
    enterEvent(e) {
      if (!helpers.isMobile()) {
        e.preventDefault();
        this.sendMessage('TEXT');
      }
    },
    resizeMsgText() {
      this.isIconColor = this.$refs.msgTextarea && this.$refs.msgTextarea.value !== '';
      if (this.$refs.msgTextarea) {
        this.$refs.msgTextarea.style.height = '1px';
        this.$refs.msgTextarea.style.height = `${this.$refs.msgTextarea.scrollHeight}px`;
      }
      this.scrollTo();
    },
    textareaFocus() {
      setTimeout(() => {
        this.scrollTo();
      }, 100);
      this.isTextareaFocus = true;
    },
    closeKeyboard() {
      // 커스텀 검색 기능
      if (document.activeElement && !this.isFaq) {
        document.activeElement.blur();
      }
    },
    changeTyping(data) {
      // 어바웃펫 입력 감지 커스텀, 한살림 입력 감지 커스텀
      if ((this.isAboutPetCustom || this.isHansalimCustom) && data.typing !== undefined && data.chatRoomId === this.chatRoomId) {
        this.isTyping = data.typing;
        // padding 늘어나서 스크롤 조작
        setTimeout(() => {
          const container = this.$refs.scrollList.$el;
          container.scrollTop = container.scrollHeight;
          window.document.body.scrollTop = container.scrollHeight;
        }, 0);
      }
    },
    getCafe24OrderList() {
      if (this.isLoadingOrderList) {
        return;
      }
      this.isLoadingOrderList = true;
      this.cafe24OrderList = [];

      const Data = {
        brandId: this.getBrandId,
        sendData: {
          member_id: this.brandQuery.loginId ? this.brandQuery.loginId : this.senderUid
        }
      };
      apiService
        .cafe24OpenApi()
        .orders.list.orderList(Data)
        .then((res) => {
          if (res.data.code === 200) {
            const data = res.data.data;
            data.orders.forEach((item) => {
              this.cafe24OrderList.push(item);
            });
          }
          this.openOrderList = true;
        })
        .catch(() => {
          this.connectConsultant();
        })
        .finally(() => {
          this.isLoadingOrderList = false;
        });
    },
    connectConsultant() {
      this.$http({
        url: `/api/external/chat/chat-rooms/${this.chatRoomId}/ai-bot/take-over`,
        method: 'PATCH'
      })
        .then(({ data }) => {
          try {
            if (data.code !== 0) {
              this.$mitt.emit('DialogPopup', {
                useDialog: true,
                message: '<dl class="txt"><dd>' + data.message + '</dd></dl>'
              });
            }
          } catch (e) {
            console.log(e);
          }
        })
        .catch((err) => {
          this.$mitt.emit('DialogPopup', {
            useDialog: true,
            message: '<dl class="txt"><dd>' + err + '</dd></dl>'
          });
        });
    },
    closeBottomSheet(data) {
      if (data.type === 'consult') {
        this.message = data.sendText;
        this.sendMessage('TEXT');
        this.connectConsultant();
      }

      this.openOrderList = false;
      this.cafe24OrderList = [];
      this.message = [];
    },
    checkCafe24Member() {
      const Data = {
        brandId: this.getBrandId,
        sendData: {
          member_id: this.brandQuery.loginId ? this.brandQuery.loginId : this.senderUid
        }
      };
      apiService
        .cafe24OpenApi()
        .customers.member(Data)
        .then((res) => {
          if (res.data.code === 200) {
            const data = res.data.data;
            if (data.customers.length > 0 && data.customers[0].member_id === Data.sendData.member_id) {
              this.getCafe24OrderList();
            } else {
              this.connectConsultant();
            }
          }
        })
        .catch(() => {
          this.connectConsultant();
        });
    }
  }
};
</script>
